import React from 'react';
import styled from 'styled-components';
import { useIsMobile } from '../hooks/responsive';

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const TracksImagePlaceholder = styled.div`
  background: rgba(255, 255, 255, 0);
  width: 100%;
`;

const TrackText = styled.div<{ isMobile: boolean }>`
  max-width: 450px;
  height: ${({ isMobile }) => (isMobile ? 300 : 200)}px;
  margin-top: ${({ isMobile }) => (isMobile ? '0' : '-50px')};
  align-self: center;
`;

export const Tracks: React.FC = () => {
  const { isMobile } = useIsMobile();

  return (
    <Container>
      <TracksImagePlaceholder id={'tracks-svg'} />
      <TrackText id={'track-text'} isMobile={isMobile} />
    </Container>
  );
};
